import axios from 'axios';
import { toast } from 'react-toastify';
import '../Sys/config';
import {
  expireImpersonation,
  exitImpersonation,
  getAuthorizationValue,
  isImpersonating,
  shouldNotify,
  startImpersonation,
} from './impersonationSession';
import { isLearningHubUnavailableResponse } from '../utils/learningHubAvailability';

const notify = (type, content) => toast(content, { type });

function isRelative(url) {
  return !/^https?:\/\//i.test(url || '');
}

function isDeviareApiUrl(url) {
  if (isRelative(url)) return true;
  const platform = global.platformURI || '';
  if (platform && String(url).startsWith(platform)) return true;
  try {
    const host = new URL(url).host;
    return host.endsWith('deviare.africa') && host.startsWith('api');
  } catch (error) {
    return false;
  }
}

export function applyDeviareAuthorization(config) {
  const requestConfig = config || {};
  if (!isDeviareApiUrl(requestConfig.url || '')) return requestConfig;
  const authorization = getAuthorizationValue();
  if (!authorization) return requestConfig;
  requestConfig.headers = requestConfig.headers || {};
  if (typeof requestConfig.headers.set === 'function') {
    requestConfig.headers.set('Authorization', authorization);
  } else {
    requestConfig.headers.Authorization = authorization;
  }
  if (isRelative(requestConfig.url) && !requestConfig.baseURL && global.platformURI) {
    requestConfig.baseURL = global.platformURI;
  }
  return requestConfig;
}

function notifyImpersonation(type, message) {
  if (shouldNotify(message)) {
    notify(type, message);
  }
}

function install() {
  if (axios.__deviareAuthInstalled) return;
  axios.__deviareAuthInstalled = true;
  axios.interceptors.request.use((config) => applyDeviareAuthorization(config));
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (isImpersonating() && status === 401 && expireImpersonation()) {
        notifyImpersonation(
          'info',
          'This sign-in session has expired. You are back on the superadmin account.'
        );
      } else if (
        isImpersonating()
        && status === 403
        && !isLearningHubUnavailableResponse(error?.response?.data)
      ) {
        notifyImpersonation(
          'error',
          error?.response?.data?.message
            || 'This action is blocked while signed in as a user. Return to the superadmin account first.'
        );
      }
      return Promise.reject(error);
    }
  );
}

install();

export function beginImpersonation(userUuid, reason) {
  return startImpersonation(userUuid, reason, axios);
}

export function endImpersonation() {
  return exitImpersonation(axios);
}
